"use strict";

window.addEventListener('DOMContentLoaded', function (event) {
  var overviewContainer = document.querySelector('.doctor-bio-overview');
  var readMoreTrigger = document.querySelector('.doctor-bio-overview__read-more');
  var hiddenContent = document.querySelector('.doctor-bio-overview__content');
  var videoContent = document.querySelector('.doctor-bio-overview__right');
  var topContent = document.querySelector('.doctor-bio-overview__inner-top');
  if (overviewContainer) {
    readMoreTrigger.addEventListener('click', function (event) {
      hiddenContent.classList.add('full-content');
    });
    if (!videoContent) {
      topContent.classList.add('full-content');
    }
    var mediaQuery = window.matchMedia('(min-width: 576px)');
    var heightContent = document.querySelector('.doctor-bio-overview__wrapper').offsetHeight;
    if (mediaQuery.matches) {
      if (heightContent < 230) {
        readMoreTrigger.classList.add('hide');
      }
    } else {
      if (heightContent < 350) {
        readMoreTrigger.classList.add('hide');
      }
    }
  }
});